<div class="table-header-selector-container">
	<strong>{{ data.title }}</strong>
	<section class="btnsSection">
		@for (selector of data.selectors; track selector.id) {
		<button
			(mouseup)="data.onClickFunction(selector.id); data.selected = selector.id"
			(keyup.enter)="data.onClickFunction(selector.id); data.selected = selector.id"
			class="selector"
			[class.selected]="data.selected === selector.id"
		>
			{{ selector.btnLabel }}
		</button>
		}
	</section>
</div>
